import { render, staticRenderFns } from "./PermissionForm.vue?vue&type=template&id=36a2379a&scoped=true&"
import script from "./PermissionForm.vue?vue&type=script&lang=js&"
export * from "./PermissionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2379a",
  null
  
)

export default component.exports